import { api } from '../api/client'
import type { Media } from '../api/types'

/**
 * The thumbnail goes after the photo, and its failure is none (#57).
 *
 * It is a speed-up, not content: if it does not get through, the tile shows
 * the original -- slower, but complete. A photo stuck in the outbox because
 * its little picture did not arrive would be the worse trade.
 *
 * **One place for two roads** (1.3.0): the upload hook and the outbox. The
 * outbox used to send only the photo, so every photo written offline stayed
 * without a thumbnail for good -- and offline is the normal case on a trip.
 */
export async function vorschauHochladen(mediaId: number, thumb: Blob | null | undefined): Promise<Media | null> {
  if (thumb == null) return null
  try {
    return await api.upload<Media>(`/api/media/${mediaId}/thumb`, thumb)
  } catch {
    return null
  }
}
